import type { TJoinStep } from '../models/joinSteps.types'

type TPreviousJoinDestination = TJoinStep | 'community'

/**
 * Previous destination before `stepName`.
 * The first step in the list (and any step absent from the list) goes back to the community page.
 */
export const getPreviousJoinStep = (stepName: TJoinStep, steps: TJoinStep[]): TPreviousJoinDestination => {
  const index = steps.indexOf(stepName)
  if (index > 0) {
    return steps[index - 1] ?? 'community'
  }
  return 'community'
}
